import qs from 'qs';
import { fetchGET, fetchPOST, fetchDELETE, fetchPATCH } from 'api/fetchHelper';

const PATH = '/_api/v1/galleries';

const Galleries = {
  getAll: ({ page, filter, sort, fields, include }) => (
    fetchGET(`${PATH}?${qs.stringify({ page, filter, sort, fields, include }, { encodeValuesOnly: true })}`)
  ),

  get: ({ galleryId, include, fields } = {}) => {
    if (!galleryId) throw new Error('galleryId is not defined');
    return fetchGET(`${PATH}/${galleryId}?${qs.stringify({ include, fields }, { encodeValuesOnly: true })}`);
  },

  patch: ({ galleryId, body, include } = {}) => {
    if (!galleryId) throw new Error('galleryId is not defined');
    return fetchPATCH(`${PATH}/${galleryId}?${qs.stringify({ include }, { encodeValuesOnly: true })}`, body);
  },

  create: ({ body, include }) => fetchPOST(`${PATH}?${qs.stringify({ include })}`, body),

  delete: ({ galleryId } = {}) => {
    if (!galleryId) throw new Error('galleryId is not defined');
    return fetchDELETE(`${PATH}/${galleryId}`);
  },
};

export default Galleries;
